import type { AgencyPolicySection } from "./agency-policy-content";

export const agencyRewardSections: AgencyPolicySection[] = [
  {
    id: "invitation-rewards",
    title: "合营人头费奖励",
    blocks: [
      {
        type: "table",
        caption: "合营人头费奖励",
        columns: ["直属有效邀请会员", "邀请奖励", "发放奖励"],
        rows: [
          ["1个", "700元/个", "700元"],
          ["2个", "700元/个", "1400元"],
          ["3个", "700元/个", "2100元"],
          ["4个", "800元/个", "3200元"],
          ["5个", "900元/个", "4500元"],
          ["6个", "1000元/个", "6000元"],
          ["7个", "1100元/个", "7700元"],
          ["8个", "1200元/个", "9600元"],
          ["9个", "1300元/个", "11700元"],
          ["10个", "1500元/个", "15000元"],
        ],
        note: "奖励上不封顶 100个有效会员，奖励发放15W元！",
      },
      {
        type: "paragraph",
        emphasis: true,
        text: "活动每10天统计一次，每月共3期每期结束后系统将在3天内自动完成奖励发放，奖励直接发放至账户；",
      },
      {
        type: "list",
        ordered: true,
        items: [
          "第一期（上旬）：每月1日–10日统计，11日–13日发放；",
          "第二期（中旬）：每月11日–20日统计，21日–23日发放；",
          "第三期（下旬）：每月21日至月底统计，次月1日–3日发放；",
        ],
      },
      {
        type: "list",
        items: [
          "有效人数标准：单个活动周期内，会员累计充值≥500且有效投注流水≥3000为1名有效会员。（不计算上级转账金额，排除28游戏投注流水、CG飞行员、CG红包/翻牌牛牛游戏，审核活跃度多账户、闪客凑数不计算有效会员）",
          "计算单独周期内新增注册有效人数；例：下级A注册时间3月21日，那A的数据只计算在下旬周期；",
          "为避免对文字的理解差异，平台保留在任何时候修改此项优惠活动条款与规则的权利（包括暂停或取消此项优惠活动等）；",
        ],
      },
    ],
  },
  {
    id: "weekly-rewards",
    title: "合营周流水奖励",
    blocks: [
      {
        type: "table",
        caption: "合营周流水奖励",
        columns: ["周流水", "周有效新增人数", "奖励"],
        rows: [
          ["1w", "1", "58"],
          ["10w", "2", "108"],
          ["20w", "3", "208"],
          ["50w", "5", "388"],
          ["100w", "10", "888"],
          ["300w", "30", "1888"],
          ["600w", "50", "3888"],
          ["1000w", "100", "8888"],
        ],
      },
      {
        type: "paragraph",
        text: "有效新增定义：当周注册且累计存款≥500元，或当周注册存款≥100且有效投注流水≥1000；",
      },
      {
        type: "paragraph",
        text: "例：流水达标100w，有效新增达标5个，则领取388元奖励。请勿纠结；",
      },
      {
        type: "paragraph",
        text: "每人每周限参与一次，达标将在次周一20:00发放至合营账户，流水+有效新增均达标才可领奖，且按达标最低档位发放奖励；",
      },
      {
        type: "paragraph",
        emphasis: true,
        text: "合营计划代理，计算直属下级流水：电子+棋牌+捕鱼+体育+电竞+真人类型游戏数据；不计算游戏：28类游戏/CG飞行员/CG红包/翻牌牛牛游戏。",
      },
      {
        type: "list",
        items: [
          "平台会对参与活动的有效会员的复存率及有效投注进行审核，若因此而被风控限制，则平台有权取消代理及线下会员的活动奖励申请资格，任何用户或团体以不正常方式进行套取活动优惠，平台方保留在不通知的情况下冻结或关闭相关账户的权利，并不退还款项，且用户会被列入黑名单。",
          "为避免对文字的理解差异，平台保留在任何时候修改此项优惠活动条款与规则的权利（包括暂停或取消此项优惠活动等）。",
        ],
      },
    ],
  },
  {
    id: "partner-plan",
    title: "合营伙伴扩展计划",
    blocks: [
      { type: "heading", text: "一、推荐加入享高额提成分佣" },
      {
        type: "table",
        caption: "推荐加入享高额提成分佣",
        columns: ["介绍代理提成总额", "有效活跃代理", "提成分佣"],
        rows: [
          ["1000", "2", "2%"],
          ["5000", "3", "4%"],
          ["10000", "5", "6%"],
          ["50000", "10", "8%"],
          ["100000", "15", "9%"],
          ["300000", "30", "10%"],
        ],
      },
      { type: "paragraph", text: "活动周期15天一次，一个月2次；" },
      {
        type: "list",
        items: [
          "上旬1~15号数据，16~18号自动发放到合营账户；",
          "下旬16～月底最后一天，次月1~3号自动发放到合营账户；",
        ],
      },
      {
        type: "paragraph",
        text: "例：代理A介绍B+C+D加入合营计划代理，B+C+D在上半月内收益提成金额共5000元，即A可拿到5000×4%=200元，以此类推，介绍代理提成收益越高，活跃代理越多，提成分佣奖励越高！",
      },
      {
        type: "paragraph",
        text: "注：介绍人在平台必须为有效代理。且被推荐人必须为推荐人的直属合营下级（邀请好友下级不参与），请在注册后第一时间留言合营代理管理绑定关系并参与活动。",
      },
      {
        type: "paragraph",
        emphasis: true,
        text: "有效代理定义：周期内直属新增大于3个且每个下级充值需大于500。",
      },
      {
        type: "paragraph",
        text: "注：被推荐代理必须是有效活跃代理，有效新增玩家必须是在平台拥有唯一账户，多账号将不被计算有效新增；",
      },
      {
        type: "list",
        items: [
          "有效活跃代理=周期内新增有效直属下级≥3个；",
          "有效新增=周期内注册且存款≥500或存款≥100且有效投注≥1000；",
        ],
      },
      { type: "paragraph", text: "注：成功推荐代理后，即可长期领取提成分佣；" },
      {
        type: "list",
        items: [
          "严禁个人或团队以不正常行为或手段进行获利，凑数，卡标准平台有权取消奖励或作出严厉处罚；",
          "平台对本活动保留最终解释权，可在未充分通知的前提下对活动细节进行修订或终止活动。",
        ],
      },
      { type: "heading", text: "二、推荐加入享佣金分成奖励" },
      {
        type: "table",
        caption: "推荐加入享佣金分成奖励",
        columns: ["介绍代理个数", "提成分佣比例"],
        rows: [
          ["1个", "4%"],
          ["2个", "5%"],
          ["3个", "6%"],
          ["4个", "7%"],
          ["≥10个", "10%"],
        ],
      },
      {
        type: "paragraph",
        text: "例：代理A介绍B加入合营计划代理，B当月净利润有50w且当月B线下有5个有效会员，即A可拿到奖励金额为50万*4%=2万；如代理A成功介绍10个有效代理，则A的提成比例为10%，可拿到奖励金额为50万*10%=5万",
      },
      {
        type: "list",
        items: [
          "注：介绍人在平台必须为有效代理。且被推荐人必须为推荐人的直属合营下级（邀请好友下级不参与），请在注册后第一时间留言参与活动。如被邀请人留言时已产生代理数据，则无法参加此活动。",
          "注：被推荐代理需达标分红佣金标准，且推荐人也必须为有效代理，推荐人才可以领取推荐奖励。",
          "注：被推荐代理必须要是活跃代理，每个月5个有效新增以上，有效新增玩家必须是在平台拥有唯一账户，多账号将不被计算有效新增；",
          "注：成功推荐代理后，即可长期领取对应佣金提成，被介绍代理佣金按实际发放到账的佣金比例，",
        ],
      },
      {
        type: "paragraph",
        emphasis: true,
        text: "有效代理定义：当月直属新增大于3个且每个下级充值需大于500。",
      },
      { type: "paragraph", emphasis: true, text: "相信品牌的力量" },
    ],
  },
];
